const ChannelReport = () =>
  import('@/views/main/wechatMgmt/channelReport/ChannelReport.vue')
export default {
  path: '/main/wechatMgmt/channelReport',
  name: 'ChannelReport',
  component: ChannelReport
}
